import React from "react";

export default function TeacherDetailProfileSection({ teacher }) {
  return (
    <div className="flex flex-col items-center text-center mb-8">
      <div className="relative mb-4">
        <div className="w-28 h-28 rounded-[2.5rem] overflow-hidden shadow-lg border-4 border-white bg-white">
          {teacher.name === "담임목사님" ? (
            <div className="w-full h-full bg-gradient-to-br from-purple-100 to-purple-50 flex items-center justify-center text-purple-700 font-black text-5xl">
              ✞
            </div>
          ) : teacher.photoUrl ? (
            <img src={teacher.photoUrl} alt="Profile" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full p-2 bg-white flex items-center justify-center">
              <img
                src={teacher.gender === "남" ? "/images/teacher_animated_light.png" : "/images/woman_teacher_animated_light.png"}
                alt="Profile"
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>
      </div>
      <h2 className="text-3xl font-extrabold text-gray-900 mb-1">{teacher.name}</h2>
      <div className="flex flex-col items-center gap-2">
        <p className="text-gray-500 font-medium text-lg">
          {teacher.charge || "담당 없음"}
          {(teacher.responsibility || teacher.role) && <span className="mx-2">•</span>}
          {teacher.responsibility && <span className="text-gray-600">{teacher.responsibility}</span>}
          {teacher.responsibility && teacher.role && <span className="mx-1">•</span>}
          {teacher.role && <span className="text-gray-500">{teacher.role}</span>}
        </p>
      </div>
    </div>
  );
}
